<div class="editor">

  <!-- --------------------------------------------------------- TIÊU ĐỀ MỞ RỘNG --------------------------------------------------------- -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>

  <!-- ----------------------------------------------------------- MENU CONFIG ----------------------------------------------------------- -->
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config 
      [elementChoosing]="objectChoosing" 
      [device]="device" 
      [id_parent_choose]="objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object">
    </app-position-out-config>

    <app-width-height-config   
      [device]="device"   
      [elementChoosing]="objectChoosing" 
      [width]="class['text-price']['width']"
      (changeWidthHeight)="changeWidthHeight($event)">
    </app-width-height-config>

    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- CHỮ VÀ ĐỊNH DẠNG -->
      <li nz-submenu [nzTitle]="'chu_va_dinh_dang' | translate" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <!-- Hiển thị đơn vị tiền tệ -->
        <div class="config-name">
          <p>{{'hien_thi_don_vi_tien_te' | translate}}</p>
          <nz-switch [(ngModel)]="config['currency']['currency_check']" (ngModelChange)="updateConfig()"></nz-switch>
        </div>        
        
        <!-- Nội dung -->
        <div>
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div class="mb-3">
            
          </div>
          <div style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'noi_dung' | translate}}</mat-label>
              <textarea matInput 
                [ngModel]="staticdata['text_' + functionService.selectedLanguageCode] | vhLanguage : 'text' : objectChoosing.component" 
                (ngModelChange)="staticdata['text_' + functionService.selectedLanguageCode] = $event" 
                (blur)="updateContent('text')"></textarea>
            </mat-form-field>
          </div>
        </div>

        <div class="field-row">
          <div class="config-font-size">
            <!-- Font Family -->
            <div class="field-row-font">
              <mat-form-field style="width:100%">
                <mat-label>Font</mat-label>
                <mat-select [(ngModel)]="class['text-price__wrapper']['font-family']" (ngModelChange)="updateClass();">
                  <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <!-- Font size -->
            <div class="field-row-size">
              <mat-form-field style="width:100%">
                <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                <input matInput type="number" [min]="1" [max]="200"
                  [ngModel]="class['text-price__content']['font-size'] | vhnumber"
                  (ngModelChange)="class['text-price__content']['font-size'] = $event +'px'"
                  (blur)="updateClass()">
              </mat-form-field>
            </div>
          </div>
        </div>
        <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
        <div class="field-row">
          <div class="config-font">
            <p class="title">{{'kieu_chu' | translate}}</p>
            <div class="font">
              <!-- In đậm -->
              <button class="font-text-btn font-text-btn-bold" title="bold" nz-button 
                [nzType]="class['text-price__content']['font-weight'] == 'bold' ? 'primary' : 'default'"
                (click)="class['text-price__content']['font-weight'] =
                  class['text-price__content']['font-weight'] == 'bold'
                    ? '400'
                    : 'bold'"
                (click)="updateClass()">
                <span style="font-weight: 500;">B</span>
              </button>
              <!-- In nghiêng -->
              <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button 
                [nzType]="class['text-price__content']['font-style'] == 'italic' ? 'primary' : 'default'"
                (click)="class['text-price__content']['font-style'] =
                  class['text-price__content']['font-style'] == 'normal'
                    ? 'italic'
                    : 'normal'"
                (click)="updateClass()">
                <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <!-- Gạch dưới -->
              <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button 
                [nzType]="class['text-price__wrapper']['text-decoration'] == 'underline' ? 'primary' : 'default'"
                (click)="class['text-price__wrapper']['text-decoration'] =
                  class['text-price__wrapper']['text-decoration'] == 'none'
                    ? 'underline'
                    : 'none'"
                (click)="updateClass()">
                <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <input class="input-color" type="button"
                style="width:20%;flex:none;border-radius:5px;"
                [cpOKButton]="true" 
                [style.background]="class['text-price__wrapper']['color']"
                [(colorPicker)]="class['text-price__wrapper']['color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </div>
        </div>
        <!-- Canh lề -->
        <div class="field-row">
          <div class="config-font">
            <p class="title">{{'canh_le' | translate}}</p>
            <div class="font">
              <button class="font-text-btn" nz-button
                [nzType]="
                  class['text-price__wrapper']['justify-content'] == 'flex-start'
                    ? 'primary'
                    : 'default'
                "(click)="
                  class['text-price__wrapper']['justify-content'] = 'flex-start';
                  class['text-price__content']['text-align'] = 'left';
                "(click)="updateClass();">
                <i nz-icon nzType="align-left" nzTheme="outline"></i>
              </button>
              <button class="font-text-btn" nz-button
                [nzType]="
                  class['text-price__wrapper']['justify-content'] == 'center'
                    ? 'primary'
                    : 'default'
                "(click)="
                  class['text-price__wrapper']['justify-content'] = 'center';
                  class['text-price__content']['text-align'] = 'center';
                "(click)="updateClass();">
                <i nz-icon nzType="align-center" nzTheme="outline"></i>
              </button>
              <button class="font-text-btn" nz-button
                [nzType]="
                  class['text-price__wrapper']['justify-content'] == 'flex-end'
                    ? 'primary'
                    : 'default'
                "(click)="
                  class['text-price__wrapper']['justify-content'] = 'flex-end';
                  class['text-price__content']['text-align'] = 'right';
                "(click)="updateClass();">
                <i nz-icon nzType="align-right" nzTheme="outline"></i>
              </button>
              <button class="font-text-btn" nz-button
                [nzType]="
                  class['text-price__content']['text-align'] == 'justify'
                    ? 'primary'
                    : 'default'
                "(click)="
                  class['text-price__wrapper']['justify-content'] = '';
                  class['text-price__content']['text-align'] = 'justify';
                "(click)="updateClass();">
                <i class="bi bi-justify"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Khoảng cách chữ -->
        <app-letter-spacing-config
          [objectChoosing]="objectChoosing"
          [device]="device"
          [class]="class"
          [classLetterSpacing]="class['text-price__content']"
          (updateClass)="updateClass()">
        </app-letter-spacing-config>

        <!-- Khoảng cách dòng -->
        <app-line-height-config
          [objectChoosing]="objectChoosing"
          [device]="device"
          [class]="class"
          [classLineHeight]="class['text-price__content']"
          (updateClass)="updateClass()">
        </app-line-height-config>
      </li>

      <!-- PHONG CÁCH -->
      <li nz-submenu [nzTitle]="'phong_cach_va_kieu_co' | translate" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-text-style-config
          [objectChoosing]="objectChoosing"
          [config]="config"
          [class]="class"
          [staticdata]="staticdata"
          [device]="device"
          [textContentClass]="class['text-price__content']"
          [textWrapperClass]="class['text-price']"
          [filterConfig]="config['text-shadow']"
          [isShape]="false">
        </app-text-style-config>
      </li>

      <!-- HIỆU ỨNG -->
      <li nz-submenu [nzTitle]="'hieu_ung' | translate" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" 
          [id_object]="objectChoosing._id" 
          [device]="device" 
          [class]="class" 
          [config]="config" 
          [staticdata]="staticdata"
          [cursorClass]="class['text-price']" 
          [effect_hover]="effect_hover" 
          [customize]="customize" 
          [type]="'object'"
          [effectFileUsing]="'text'"
          (openAnimationDetail)="openAnimationDetail($event)">
        </app-choose-animations-config>
      </li>
      <!-- HIỂN THỊ -->
      <li nz-submenu [nzTitle]="'hien_thi' | translate" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
        <app-hide-show-config 
          [device]="device" 
          [elementChoosing]="objectChoosing">
        </app-hide-show-config>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="this.config['animation-selected'].id != '000000'">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing"
        [id_object]="objectChoosing._id"
        [device]="device"  
        [staticdata]="staticdata" 
        [customize]="customize">
        </app-animations-config>
    </div>
  </div>
</div>